<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>
                            Thông kê đơn vị đã xác nhận dữ liệu
                        </strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col offset-md="3">
                                <b-form-group label="Đơn vị xác nhận:"
                                              label-for="manualType"
                                              :label-cols="4" label-cols-md="2"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="col-md-6 no-padding">
                                        <top-level-unit v-model="searchForm.unitId"></top-level-unit>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="3">
                                <b-form-group label="" :label-cols="4" label-cols-md="2">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            dataUrl="data/verify-data"
                            gridName="Danh sách đơn vị đã xác nhận"
                            ref="verifyDataTable">
                        <template v-slot:cell(verifyDate)="row">
                            {{ row.value | formatTime }}
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <b-button size="sm" :to="{ path: `./${row.item.id}` }" title="xem" variant="info">
                                    Xem
                                </b-button>
                            </b-button-group>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { mixins } from '@/shared/mixins'
    export default {
        name: 'ListVerifyData',
        mixins: [mixins],
        data() {
            return {
                searchForm: {
                    unitId: null
                },
                gridOptions: {
                    fields: [
                        { key: 'unitCode', label: 'Mã đơn vị', sortable: true, sortDirection: 'asc' },
                        { key: 'unitName', label: 'Tên đơn vị', sortable: true, sortDirection: 'asc' },
                        { key: 'verifyDate', label: 'Ngày xác nhận', sortable: true, },
                        { key: 'verifyUserName', label: 'Người xác nhận', sortable: true },
                    ],
                    sortBy: 'unitCode',
                    sortDesc: true,
                },
            }
        },
        computed: {
        },
        created() {
        },
        mounted() {
        },
        methods: {
            search() {
                this.$refs.verifyDataTable.refresh();
            }
        }
    }
</script>
<style scoped>
</style>
